import { render, staticRenderFns } from "./PrivateRelayWarningDialog.vue?vue&type=template&id=dd74e056&scoped=true"
import script from "./PrivateRelayWarningDialog.vue?vue&type=script&lang=js"
export * from "./PrivateRelayWarningDialog.vue?vue&type=script&lang=js"
import style0 from "./PrivateRelayWarningDialog.vue?vue&type=style&index=0&id=dd74e056&prod&scoped=true&lang=css"
import style1 from "./PrivateRelayWarningDialog.vue?vue&type=style&index=1&id=dd74e056&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd74e056",
  null
  
)

export default component.exports